// extracted by mini-css-extract-plugin
export default {"Label":"RuIby"};